// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"a65b8cd3","250":"b0e50fab","300":"32389567","455":"a244b48e","644":"bfc9ca08","712":"8dae74fe","931":"483d0df1","955":"21acc824","977":"b3671515"}[chunkId] + ".chunk.js";
};